"use strict";
function Email(email) {
    return {
        raw: email,
        get validate() {
            if (!email)
                return false;
            return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email || '');
        },
    };
}
window.Email = Email;
//# sourceMappingURL=index.js.map